import { UiContext } from 'shared/lib/contexts/uiContext';
import { useContext } from 'react';

export const useGeneralAdaptive = () => {
  const {
    spacings: {
      general,
      mainPage: { searchWrapper },
    },
  } = useContext(UiContext);

  return {
    generalPaddingX: {
      mobile: 5,
      laptop: general.paddingX,
    },
    generalPaddingY: {
      mobile: 10,
      laptop: general.paddingY,
    },
    searchWrapperPaddingY: {
      mobile: 8,
      tablet: 14,
      laptop: searchWrapper.paddingY,
    },
  };
};
